import React from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import GiftGalleryTable from './components/GiftGalleryTable'
import GiftGalleryForm from './components/GiftGalleryForm'

// Breadcrumbs
const crmBreadcrumb: PageLink = {title: 'CRM', path: '/', isSeparator: false, isActive: false}
const crmGiftGalleryBreadcrumb: PageLink = {
  title: 'Gift Gallery',
  path: '/crm/gift-gallery',
  isSeparator: false,
  isActive: true,
}

function GiftGalleryPage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Gift Gallery</PageTitle>
              <GiftGalleryTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmGiftGalleryBreadcrumb]}>
                Add Gift Gallery
              </PageTitle>
              <GiftGalleryForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmGiftGalleryBreadcrumb]}>
                Edit Gift Gallery
              </PageTitle>
              <GiftGalleryForm />
            </>
          }
        />
      </Route>

      {/* Page Not Found */}
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default GiftGalleryPage
